import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { makeRequest } from "../../utils/makeRequest";
import toastNotify from "../../utils/toastNotify";
import * as urls from "../../utils/urlConst";
import { handleNotificationData, handleNotificationLoader } from "../../redux/Notification";
import Loader from "../Loader";
import { exceptionLog } from "../../utils/common";
import { getNotificationAlerts } from "../../apiService/apiService";


const Notification = ({ notificationRef, isNotificationOpen, setIsNotificationOpen }: any) => {
  const screenWidth = useSelector((state: any) => state.layout.currentScreenWidth);
  const notificationData = useSelector((state: any) => state.notification.notificationData);
  const isNotificationLoader = useSelector((state: any) => state.notification.isNotidicationLoader);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const replaceTag = () => {
  //     const tempDiv = document.createElement("div");
  //     const data = originalHTML.map((item: any) => {
  //       tempDiv.innerHTML = item;
  //       return tempDiv.textContent || tempDiv.innerText;
  //     });
  //     setReplce(data);
  //   };s
  //   replaceTag();
  // }, [notificationData]);

  const removeTag = (data: any) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = data;
    return tempDiv.textContent || tempDiv.innerText
  }

  const fetchNoticationDetails = async (TranCode: string, flag: string) => {
    try {
      dispatch(handleNotificationLoader(true))
      const payload = {
        TranCode: TranCode,
        Type: flag
      };
      const config = {};
      await makeRequest('POST', urls.getNotificationDetail, payload, config).then(async (result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setIsNotificationOpen(false);

          const notificationData = await getNotificationAlerts();
          dispatch(handleNotificationData(notificationData))
          if (flag === "A") {
            navigate('/announcement', {
              state: {
                data: response,
              }
            });
          } else if (flag === "C") {
            navigate('/circular', {
              state: {
                data: response,
              }
            });
          }
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get notification details", "N");
      }
    } finally {
      dispatch(handleNotificationLoader(false))
    }
  };

  return (
    <div>
      {isNotificationOpen && <div className={`${screenWidth <= 875 && "bg-mobile"}`}></div>}

      <div className={`notification-section ${screenWidth >= 875 ? "" : "Mobilenotifaction-section"} `} ref={notificationRef}>
        <div className="section-header">
          <div className="notification-heading">Notification</div>
        </div>
        {!isNotificationLoader ?
          <>
            {notificationData.map((data: any, i: number) => (
              <div key={i}>
                <div className="notification-Divider"></div>
                <div className={`user-Notification ${data.ReadStatus === "N" ? "ticket-unread" : ""}`} onClick={() => fetchNoticationDetails(data.TranCode, data.Flag)}>
                  <div>
                    {data.Flag === "A" && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-danger text-lg'>A</div>}
                    {data.Flag === "C" && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-warning text-lg'>C</div>}
                  </div>
                  <div className="notification-text">
                    <div className="username" style={{ width: 220, textOverflow: "ellipsis", textWrap: "nowrap", overflow: "hidden" }}>{data.Title}</div>
                    <div className="text-msg text-slate-500" style={{ width: 220, maxHeight: "40px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: 'wrap' }}>{removeTag(data.Description)}</div>
                  </div>
                </div>
              </div>
            ))}
          </>
          : <div style={{ height: '300px' }} className='d-flex justify-content-center align-items-center'>
            <Loader />
          </div>
        }
      </div>
    </div>
  );
};

export default Notification;
